import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { cx } from '@emotion/css';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './Electrical.module.scss';

export const Electrical = () => {
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink="/images/services/electrical/electrical-top.jpeg"
        imageAlt="Electrical service banner image"
        title="Electrical"
      />

      <section className={styles.services}>
        <div className={styles.root}>
          <div className={styles.services_card_block}>
            <div className={styles.container}>
              <div className={[styles.inner_section, styles.root].join()}>
                <TitleAndDescComponent
                  styles={styles}
                  title="Reliable Electrical Services across London"
                  description={
                    <>
                      From lighting repairs to full rewiring, our certified{' '}
                      <b> emergency electricians</b> provide fast, dependable
                      solutions for London homeowners, landlords and property
                      managers. No job is too small, no project too complex – we
                      keep your property safe, compliant, and fully powered.
                    </>
                  }
                />

                <CTAButton
                  title="Book an Electrician"
                  serviceName="Electrical"
                />

                <div
                  className={cx(
                    styles.wrap_section,
                    styles.service_content_container,
                  )}>
                  <TitleAndDescComponent
                    styles={styles}
                    subTitle="Electrical Services"
                  />
                  <div className={styles.service_items}>
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/electrical/electrical.jpg"
                      imgAlt="Electrician examining wires for faults"
                      title="Electrical Fault Finding & Repairs"
                      description="Electrical faults can be dangerous if not identified and repaired quickly. Our skilled electricians specialise in fault finding, using the latest diagnostic tools to locate and fix issues efficiently. Whether it's flickering lights, tripped circuits, or other electrical problems, our team is ready to provide safe and reliable repairs."
                    />

                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/electrical/Fuse Box.webp"
                      imgAlt="fuse box"
                      title="Fuse Box Replacement"
                      description="A modern fuse box is essential for the safety and reliability of your property's electrical system. We provide fuse box replacements to ensure your home or business is equipped with up-to-date circuit protection. Our emergency electricians are available to upgrade or replace outdated fuse boxes, providing enhanced safety and compliance with current regulations."
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/electrical/Rewiring.webp"
                      imgAlt="Electrician wiring property"
                      title="Rewiring"
                      description="Old or faulty wiring can be a serious safety risk, increasing the chance of electrical fires or system failures. Our rewiring services are designed to bring your property's electrical system up to modern standards, whether you're updating an older building or expanding your property. Our professional team makes the rewiring process straightforward, ensuring minimal disruption and maximum safety."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.root}>
        <EmergencyComponent
          title="Emergency Electrician Near Me"
          imageSrc="/images/services/electrical/electrical.jpeg"
          imageAlt="Emergency Electrical services"
          styles={styles}
          para1="Electrical issues like flickering lights, tripped circuit breakers, or sparking outlets can quickly escalate into serious hazards, including fires or property damage. For homeowners and tenants, these disruptions are not only inconvenient but also stressful, especially when power outages or faulty wiring are frequent."
          para2="Our electricians are ready to respond to your needs, adjusting our schedule to get a qualified professional to your property as quickly as possible. Available 7 days a week, we prioritise providing prompt, reliable service."
        />
        <ListOfServices
          styles={styles}
          serrviceList={[
            { name: 'Electrical fault finding & repairs' },
            { name: 'Fusebox replacement' },
            { name: 'Rewiring' },
            { name: 'Electrical fittings' },
            { name: 'Electric boilers' },
            { name: 'Consumer unit replacement' },
            { name: 'Electric radiators' },
            { name: 'Immersion heaters' },
            { name: 'Garden lighting' },
            { name: 'Exterior lighting' },
            { name: 'Lighting repair' },
            { name: 'Sockets' },
            { name: 'Switches' },
            { name: 'Power shower installation' },
          ]}
        />
        <AreasWeCover styles={styles} />
        <PostCodes styles={styles} mainPageUrl="/services/electrical" />
        <FAQsView title="Electrical FAQs" faqItems={faqItems} />
      </div>
    </>
  );
};
// {name: ""},

const faqItems = [
  {
    title: 'How often should I have my electrics inspected?',
    details: `Homeowners should have their electrics inspected every 10 years, while landlords need inspections every 5 years. If you notice any issues, get them checked sooner.`,
  },
  {
    title: 'Do I need an Electrical Installation Condition Report (EICR)?',
    details:
      'Yes, landlords legally need an EICR every 5 years for their tenants. Homeowners can also benefit from an EICR to ensure their electrical systems are safe.',
  },
  {
    title: 'What electrical work can I do myself?',
    details: `You can safely handle minor work, like changing a light switch or socket faceplate. However, leave complex jobs—like new installations, circuit changes, or work in areas like bathrooms—to a qualified electrician.`,
  },
  {
    title: 'How can I tell if my property’s wiring needs replacing?',
    details: `Frequent breaker trips, flickering lights, discoloured outlets, or a burning smell are signs you may need new wiring. A qualified electrician can inspect and confirm the condition.`,
  },
  {
    title: 'Can you provide emergency electrical services?',
    details: `Yes, our electricians are available 7 days a week for urgent issues like power outages, electrical faults, and hazardous situations. `,
  },
  {
    title: 'Do your electricians offer guarantees on their work?',
    details: `All work by our Qeeper tradespeople is backed by a 12-month guarantee against any faulty workmanship.`,
  },
];
